import { useState, useEffect } from 'preact/hooks';
import Modal from './shared/Modal.jsx';
import Button from './shared/Button.jsx';

// Technische koppeling van een product: waar draait het en waar checkt 4U de
// status? De pakketten en prijzen staan in ProductPlansModal — dat is een
// commerciële wijziging en hoort niet in hetzelfde formulier.
export default function ProductFormModal({ isOpen, product, onClose, onSaved }) {
  const isEdit = !!product;
  const [name, setName] = useState('');
  const [baseUrl, setBaseUrl] = useState('');
  const [healthUrl, setHealthUrl] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setName(product?.name || '');
    setBaseUrl(product?.baseUrl || '');
    setHealthUrl(product?.healthUrl || '');
    setError(null);
  }, [isOpen, product]);

  async function submit(e) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch(isEdit ? `/api/products/${product.id}` : '/api/products', {
        method: isEdit ? 'PATCH' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ name, base_url: baseUrl, health_url: healthUrl })
      });
      const data = res.headers.get('content-type')?.includes('application/json') ? await res.json() : {};
      if (!res.ok) throw new Error(data.error || 'save_failed');
      onSaved(data);
      onClose();
    } catch (err) {
      setError(translate(err.message));
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={isEdit ? `Koppeling bewerken: ${product?.name}` : 'Nieuw product registreren'}>
      <form onSubmit={submit} class="app-form">
        <label>
          <span>Naam</span>
          <input value={name} onInput={e => setName(e.currentTarget.value)} required maxLength={120} />
        </label>
        <label>
          <span>Base URL</span>
          <input
            type="url"
            value={baseUrl}
            onInput={e => setBaseUrl(e.currentTarget.value)}
            placeholder="https://vereniging4u.nl"
            required
          />
        </label>
        <label>
          <span>Health URL</span>
          <input
            type="url"
            value={healthUrl}
            onInput={e => setHealthUrl(e.currentTarget.value)}
            placeholder="https://vereniging4u.nl/api/4u/health"
            required
          />
        </label>
        <p class="muted small">
          Het product moet <code>/api/4u/health</code> en <code>/api/4u/users</code> aanbieden.
          Bij aanmaken krijg je een token dat het product bij die calls verwacht.
        </p>
        {error && <div class="form-error">{error}</div>}
        <div class="form-actions">
          <Button variant="ghost" type="button" onClick={onClose}>Annuleren</Button>
          <Button type="submit" disabled={busy}>{busy ? 'Bezig…' : (isEdit ? 'Opslaan' : 'Registreren')}</Button>
        </div>
      </form>
    </Modal>
  );
}

function translate(code) {
  const messages = {
    invalid_input: 'Een of meer velden zijn ongeldig — controleer de URLs.',
    not_found: 'Product niet meer gevonden — herlaad de lijst.',
    save_failed: 'Opslaan is mislukt.'
  };
  return messages[code] || 'Er ging iets mis. Probeer opnieuw.';
}
